import httpClient from "../../../client/httpClient";

export const fetchBugReports = async () => {
    try {
        const res = await httpClient.get("/v1/api/customer-issues/get-all");
        return res.data;
    } catch (error) {
        console.error("Error fetching bug reports:", error);
        throw error;
    }
};

export const changeBugReportStatus = async (reportId, status) => {
    try {
        await httpClient.put(`/v1/api/customer-issues/update/${reportId}`, null, {
            params: {
                statusType: status
            }
        });
        return {
            id: reportId,
            status: status
        };
    } catch (error) {
        console.error("Error changing bug report status:", error);
        throw error;
    }
};
